import { Tab as ChakraTab } from '@chakra-ui/react'
import { TabPanel as ChakraTabPanel } from '@chakra-ui/react'

import { ComponentProps, FC } from 'react'

type ITab = ComponentProps<typeof ChakraTab>

export const Tab: FC<ITab> = ({ children, ...rest }) => (
    <ChakraTab
        sx={{
            color: 'white',
            fontWeight: 'bold',
        }}
        _active={{
            background: 'none'
        }}
        _selected={{
            bg: '#1b2d66',
            borderBottom: '3px solid #2650AC'
        }}
        paddingInlineStart={10}
        paddingInlineEnd={10}
        {...rest}
    >
        {children}
    </ChakraTab>
)

type ITabPanel = {
    widthFitScreen?: boolean
} & ComponentProps<typeof ChakraTabPanel>

export const TabPanel: FC<ITabPanel> = ({ children, widthFitScreen, ...rest }) => (
    <ChakraTabPanel
        padding={6}
        margin='auto'
        maxWidth='var(--base-width)'
        {...rest}
    >
        {children}
    </ChakraTabPanel>
)
